import { ReactElement, ReactNode } from 'react';
import { MediaTableRow } from './types';

/**
 * Helper function to handle rendering cells with uploading state checks.
 * Returns a fallback when media is uploading, otherwise renders the provided content.
 *
 * @param media - The media row data
 * @param renderer - Function that returns the content to render when not uploading
 * @param uploadingFallback - Optional custom fallback to show when uploading (defaults to "—")
 * @returns ReactElement
 */
export const renderWithUploadingCheck = (
  media: MediaTableRow,
  renderer: () => ReactNode,
  uploadingFallback: ReactNode = '—',
): ReactElement => {
  if (media.isUploading) {
    return uploadingFallback as ReactElement;
  }
  return renderer() as ReactElement;
};
